import { cn } from '../lib/utils';

// Shared brand mark — the same rounded gradient-violet square with a bold
// "$" as the app's PWA icon (public/icons/icon-512.png etc.), mirrored on the
// MiPisto landing page so the login screen, app shell, and marketing site
// all show the same mark.
export function LogoMark({ size = 34, className = '' }) {
  return (
    <div
      className={cn('rounded-[10px] bg-gradient-to-br from-violet-500 to-violet-800 flex items-center justify-center text-on-brand shrink-0', className)}
      style={{ width: size, height: size }}
    >
      <span
        aria-hidden="true"
        style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 800, fontSize: size * 0.56, lineHeight: 1 }}
      >
        $
      </span>
    </div>
  );
}

export default function Logo({ size = 34, textClassName = '', className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoMark size={size} />
      <span className={`font-bold text-white ${textClassName}`} style={{ fontFamily: 'Poppins' }}>
        Mi<span className="text-violet-400">Pisto</span>
      </span>
    </div>
  );
}
